import { apiUrls } from './api-urls';

export interface Environment {
  apiProxyUrl: string;
  ssoApiProxyUrl: string;
  postLoginProxyUrl: string;
  originUrl: string;
  redirectUri: string;
  domain: string;
  domainEnvironment: string[];
  cookieEnvironment: string;
  featureFlagUrl: string;
  upstreamEnv: string;
  goldCardEnvironment: string;
  goldCardabyssparcelUrl: string;
  qualtricksEnvCheck: string;
  clickStreamUrl: string;
  production: boolean;
  staging: boolean;
  internalAccess: boolean;
  internalSsoLogin: boolean;
  internalIntAccess: boolean;
  noPROD: boolean;
  qualtrics: boolean;
  XSRFToggle: boolean;
  timePeriodChange: boolean;
  isAdjudicationTypeFilter: boolean;
  isRadioButtonForFilters: boolean;
  vbcNewFilters: boolean;
  supressPocaReporting: boolean;
  contractorAssignment: boolean;
  toggleTrendingSummary: boolean;
  showDataConnectIssueBanner: boolean;
  enableTinLevelExperience: boolean;
  tinLevelExternalChange: boolean;
  goldCardCustomTin: boolean;
  externalGoldCardStatus: boolean;
  emulationTinLevelExperience: boolean;
  extendedTinLevelExperience: boolean;
  enableExternalQuickClip: boolean;
  geoSegPrintDesign: boolean;
  paymentsYieldReDesign: boolean;
  ProviderBriefing: boolean;
  toggleNewLoginApiChanges: boolean;
  suppressSettlements: boolean;
  /** Registers the application service worker. Honoured only in local, stage and prod. */
  serviceWorkerEnabled: boolean;
  goldCardFeatureToggle?: string;
  idleTimeOut: number;
  idleWarningTimeOut: number;
  allowedIdleUserSession: number;
  errorMessage: string;
  storagePrefix: string;
  headerKeys: { selectedCompany: string; selectedRole: string; token: string };
  storageKeys: { activeUserStorageKey: string; tokenStorageKey: string };
  sessionTimeOutKey: string;
  sessionTimeOutWarningKey: string;
  sessionMaskKey: string;
  apiUrls: typeof apiUrls & {
    bulkTinRUrl: string;
    SsoRedirectUri: string;
    SsoRedirectLogin: string;
    SsoLogoutUrl: string;
    linkLoginPage: string;
    providerLoginPage: string;
  };
  [key: string]: any;
}

/** Localhost / local development defaults */
export const environment: Environment = {
  apiProxyUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-core-api-dev/v1.0.0/',
  ssoApiProxyUrl: 'https://uhci-ui-internal-dev.optum.com/',
  postLoginProxyUrl: '/login/',
  originUrl: '/',
  redirectUri: 'https://localhost:8080/',
  domain: 'localhost',
  domainEnvironment: ['http://localhost:4200'],
  cookieEnvironment: 'LOCAL_',
  featureFlagUrl: '/feature-flags/',
  upstreamEnv: 'dev',
  goldCardEnvironment: 'dev',
  goldCardabyssparcelUrl: 'http://localhost:4200/abyss-parcel.js',
  qualtricksEnvCheck: '',
  clickStreamUrl: '',
  production: false,
  staging: false,
  internalAccess: true,
  internalSsoLogin: true,
  internalIntAccess: false,
  noPROD: true,
  qualtrics: true,
  XSRFToggle: false,
  timePeriodChange: true,
  isAdjudicationTypeFilter: true,
  isRadioButtonForFilters: true,
  vbcNewFilters: true,
  supressPocaReporting: true,
  contractorAssignment: true,
  toggleTrendingSummary: false,
  showDataConnectIssueBanner: false,
  enableTinLevelExperience: false,
  tinLevelExternalChange: false,
  goldCardCustomTin: false,
  externalGoldCardStatus: false,
  emulationTinLevelExperience: true,
  extendedTinLevelExperience: true,
  enableExternalQuickClip: false,
  geoSegPrintDesign: true,
  paymentsYieldReDesign: true,
  ProviderBriefing: true,
  toggleNewLoginApiChanges: true,
  suppressSettlements: false,
  serviceWorkerEnabled: true,
  idleTimeOut: 1620,
  idleWarningTimeOut: 180,
  allowedIdleUserSession: 360,
  errorMessage: 'empty',
  storagePrefix: '',
  headerKeys: { selectedCompany: '', selectedRole: '', token: '' },
  storageKeys: { activeUserStorageKey: '', tokenStorageKey: '' },
  sessionTimeOutKey: '',
  sessionTimeOutWarningKey: '',
  sessionMaskKey: '[REDACTED]',
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: '/bulk-api/',
    SsoRedirectUri: '',
    SsoRedirectLogin: '',
    SsoLogoutUrl: '',
    linkLoginPage: 'https://provider-stage.linkhealth.com',
    providerLoginPage: 'https://secure-nonprod.uhcprovider.com/stage/#/',
  },
};
